module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Gray_Blue.811b6d38.png";